import React, {useState, useEffect} from "react";
import { AgGridReact } from "ag-grid-react";
import {
    showAllPortfolios,
    getNewAssetLots,
    insertNewAssetLot
} from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { toast } from 'react-toastify';

function NewLots(){
   const [portfolioList, setPortfolioList] = useState([]);
   const [selectedPortfolio, setSelectedPortfolio] = useState(null);
   const [selectedPortfolioId, setSelectedPortfolioId] = useState(0);
   const [checkAllPortfolio, setCheckAllPortfolio] = useState(false);
   const [rowData, setRowData] = useState([]);
   const [selectedLots, setSelectedLots] = useState([]);

   const columnDef = [
    {header:"Portfolio Name", field:"PortfolioName"},
    {header:"Asset Name", field:"AssetName"},
    {header:"Shareclass Name", field:"ShareClassName"},
    {header:"Lot Name", field:"LotName", flex:1},
    {   header:"Initial Allocation Date", 
        field:"InitialAllocationDate",
        valueFormatter: (params) => {
            const date = new Date(params.value);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        }
    },
    {header:"Add", field:"Add", cellRenderer: 'agCheckboxCellRenderer', editable:true}
   ];

   useEffect(()=>{
    const fetchPortfolios = async()=>{
        try{
            const list = await sbaAxios({
                url: `${showAllPortfolios}/${checkAllPortfolio}`,
                method: "get",
            })
            setPortfolioList(list);
        }
        catch(e){
            setPortfolioList([]);
        }
    };
    fetchPortfolios();
   },[checkAllPortfolio]);

   const fetchNewAssetLots = async() => {
        try{
            const list = await sbaAxios({
                url: getNewAssetLots,
                params:{
                    portfolioId: selectedPortfolioId === 0 ? null : selectedPortfolioId
                }
            });
            setRowData(list);
        }
        catch(e){
            setRowData([]);
        }
   };

   useEffect(()=>{
    fetchNewAssetLots();
   },[selectedPortfolioId]);

   const handleSelectedPortfolio = (e) => {
    setSelectedPortfolio(e.value);
    setSelectedPortfolioId(e.value.PortfolioId);
   };

   const onCellValueChanged = (params) => {
    if(params.data.Add){
      const list = [...selectedLots, params.data];
      setSelectedLots(list);
    };
    if(!params.data.Add){
      const list = selectedLots.filter(item => item.Add === true)
      setSelectedLots(list);
    }
   };

   const handleAddSelectedLots = async() => {
    let count = 0;
    for(const item of selectedLots){
        const data = {
            assetLotName: item.LotName,
            portfolioId: item.PortfolioId,
            assetId: item.AssetId,
            shareClassId: item.ShareClassId,
            initAllocationDate: item.InitialAllocationDate
        }
        try{
            await sbaAxios({
                url:insertNewAssetLot,
                data: data,
                method: 'post'
            });
            count++;
        }
        catch(e){

        }
    };
    if(count === selectedLots.length){
        toast.success('Selected Lots saved successfully.');
        fetchNewAssetLots();
    }
    else{
        toast.error('Unable to save selected lots.');
        fetchNewAssetLots();
    }
   };

   return(
        <>
        <div className="contaier-fluid mt-4 mx-2">
            <div className="col">
                <div className="row">
                <div className="col-md-4">
                    <label className="label" >Portfolio</label>
                    <div>
                        <SBAComboBox
                            className="w-100"
                            data={portfolioList}
                            textField={"PortfolioName"}
                            valueField={"PortfolioId"}
                            value={selectedPortfolio}
                            onChange={handleSelectedPortfolio}
                            popupSettings={{ className: "modalDD" }}
                        ></SBAComboBox>
                    </div>
                </div>
                <span style={{width:"5px"}}>
                </span>
                <div className="col-md-2">
                    <p style={{ display: 'flex', alignItems: 'center', marginTop:'25px' ,gap:'10px'}}>
                        <input
                            type="checkbox"
                            checked={checkAllPortfolio}
                            onChange={() => setCheckAllPortfolio(!checkAllPortfolio)}
                        />
                        <label className="label">Get all portfolios</label>
                    </p>
                </div>
                </div>
                <div className="row mt-4">
                    <div class="col-lg-12 col-md-12 bg-white  rounded">
                        <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}> 
                            <AgGridReact columnDefs={columnDef} rowData={rowData} onCellValueChanged={onCellValueChanged} defaultColDef={{resizable:true}}></AgGridReact>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="m-1 d-flex justify-content-end mt-1">
                        <button className="p-sm-btn mx-1" onClick={handleAddSelectedLots} disabled={selectedLots.length === 0}>Add Selected Lots</button>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default NewLots;